import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { DocumentTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-find.dto';
import type { DocumentTypeFormInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-form.dto';
import type { DocumentTypeItemsPageInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-items-page.dto';
import type { DocumentTypeQueryInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-query.dto';
import type { DocumentTypeRegistryQueryInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-registry-query.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/document-type';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: DocumentTypeRegistryQueryInterface): Observable<DocumentTypeItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<DocumentTypeItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public override find<T>(query?: DocumentTypeQueryInterface): Observable<T[]> {
    const params = query ? this.objectToHttpParams(query) : {};
    return this.http.get<T[]>(`${this.baseUrl}/flat`, { params });
  }

  public findByCode(code: string): Observable<DocumentTypeFindInterface> {
    return this.http.get<DocumentTypeFindInterface>(this.baseUrl + '/' + code);
  }

  public updateByCode(code: string, body: DocumentTypeFormInterface): Observable<DocumentTypeFindInterface> {
    return this.http.put<DocumentTypeFindInterface>(this.baseUrl + '/' + code, body);
  }

  public deleteByCode(code: string): Observable<DocumentTypeFindInterface> {
    return this.http.delete<DocumentTypeFindInterface>(this.baseUrl + '/' + code);
  }

  public getHistoryForOne(code: string, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(this.baseUrl + '/' + code + '/history', {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
